var _path, _path2, _path3, _mask, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEnhancedBackgroundCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 24,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 25 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#13426B",
  fillRule: "evenodd",
  d: "M12.136 24c6.624 0 11.994-5.373 11.994-12S18.76 0 12.136 0C5.51 0 .14 5.373.14 12s5.37 12 11.995 12",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#13426B",
  fillRule: "evenodd",
  d: "M12.136 24c6.624 0 11.994-5.373 11.994-12S18.76 0 12.136 0C5.51 0 .14 5.373.14 12s5.37 12 11.995 12",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  fillOpacity: 0.1,
  fillRule: "evenodd",
  d: "M12.136 24c6.624 0 11.994-5.373 11.994-12S18.76 0 12.136 0C5.51 0 .14 5.373.14 12s5.37 12 11.995 12",
  clipRule: "evenodd"
})), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "b",
  width: 25,
  height: 24,
  x: 0,
  y: 0,
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M12.136 24c6.624 0 11.994-5.373 11.994-12S18.76 0 12.136 0C5.51 0 .14 5.373.14 12s5.37 12 11.995 12",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  stroke: "#fff",
  d: "M12.136 24c6.624 0 11.994-5.373 11.994-12S18.76 0 12.136 0C5.51 0 .14 5.373.14 12s5.37 12 11.995 12Z",
  clipRule: "evenodd"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)"
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.394
}, /*#__PURE__*/React.createElement("mask", {
  id: "c",
  width: 25,
  height: 24,
  x: 6,
  y: 5,
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m18.96 5.33 11.22 11.302-12.205 12.294L6.962 17.66C7.22 11.501 18.96 5.33 18.96 5.33",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M11.21 19.21c5.063 0 9.166-4.134 9.166-9.232 0-5.1-4.103-9.232-9.165-9.232S2.046 4.879 2.046 9.978s4.103 9.232 9.165 9.232",
  clipRule: "evenodd"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M18.51 5.117 12.286 4.07a1 1 0 0 0-.34 0L5.72 5.117c-.5.084-.867.52-.867 1.031v7.322c0 4.881 6.65 7.172 6.934 7.267a1.03 1.03 0 0 0 .656 0c.283-.095 6.935-2.386 6.935-7.267V6.148c0-.51-.367-.947-.867-1.031",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("mask", {
  id: "d",
  width: 16,
  height: 17,
  x: 4,
  y: 4,
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M18.51 5.117 12.286 4.07a1 1 0 0 0-.34 0L5.72 5.117c-.5.084-.867.52-.867 1.031v7.322c0 4.881 6.65 7.172 6.934 7.267a1.03 1.03 0 0 0 .656 0c.283-.095 6.935-2.386 6.935-7.267V6.148c0-.51-.367-.947-.867-1.031",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#E25829",
  fillRule: "evenodd",
  d: "M16.326 10.064a.57.57 0 0 0-.164-.4l-.797-.802a.567.567 0 0 0-.797 0l-3.845 3.87L9 10.995a.567.567 0 0 0-.797 0l-.797.8a.573.573 0 0 0 0 .802l2.122 2.132.797.802a.566.566 0 0 0 .797 0l.797-.802 4.243-4.265a.57.57 0 0 0 .164-.4",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00BD70",
  fillRule: "evenodd",
  d: "M12.164 24.188c3.35 0 8.148-.456 9.32-.573a.37.37 0 0 0 .326-.288l1.373-6a.376.376 0 0 0-.395-.459c-1.73.135-7.443.56-10.624.56-3.271 0-8.909-.424-10.623-.559a.375.375 0 0 0-.395.459l1.372 5.999a.37.37 0 0 0 .326.288c1.173.117 5.98.573 9.32.573",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m13.629 19.878-.948-.145-.424-.902c-.017-.037-.05-.081-.093-.081s-.075.044-.092.081l-.425.902-.948.145c-.047.008-.105.032-.105.091 0 .036.024.07.047.096l.687.701-.162.992q-.004.02-.004.04c0 .051.024.099.08.099q.038-.002.075-.024l.847-.468.848.468q.034.023.075.024c.055 0 .077-.048.077-.1q0-.019-.002-.04l-.162-.99.685-.702c.025-.026.05-.06.05-.096 0-.06-.061-.083-.106-.09",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 0.141,
  x2: 0.141,
  y1: 0,
  y2: 24,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.5
})))));
export default SvgEnhancedBackgroundCheck;